import React, { useState, useEffect, useRef } from "react";
import Header from "../../Common/Layout/Header";
import "flatpickr/dist/themes/material_blue.css";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../Common/Configurations/AuthContext";
import apiService from "../../Common/Configurations/APIService";
import config from "../../Common/Configurations/APIConfig";
import SightSeeingTabs from "../AllTabs/SightSeeingTabs";
import BrandedLoader from "../../Common/Layout/BrandedLoader";

const SightSeeingProducts = () => {
  const { state } = useLocation();
  const params = useParams();
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  const [searchQuery, setSearchQuery] = useState({});
  const [pageLoading, setPageLoading] = useState(false);
  const [activities, setActivities] = useState([]);
  const [filters, setFilters] = useState({
    ratings: [],
    priceRange: [100, 100000],
    durationRange: [0, 72000],
  });
  const applyFilters = (activities) => {
    console.log(activities);
    if (!Array.isArray(activities)) return [];
    return activities.filter((ac) => {
      const ratings = ac?.rating;
      const price = ac.salePrice || 0;
      const duration = ac.duration || 0;
      return (
        (filters.ratings.length === 0 || filters.ratings.includes(ratings)) &&
        duration >= filters.durationRange[0] &&
        duration <= filters.durationRange[1] &&
        price >= filters.priceRange[0] &&
        price <= filters.priceRange[1]
      );
    });
  };
  const handleFilterChange = (type, value) => {
    setFilters((prev) => {
      if (type === "ratings" || type === "duration") {
        const updated = prev[type].includes(value)
          ? prev[type].filter((v) => v !== value)
          : [...prev[type], value];
        return { ...prev, [type]: updated };
      } else if (type === "priceRange") {
        return { ...prev, priceRange: value };
      } else {
        return { ...prev, [type]: value };
      }
    });
  };
  const handleClearFilters = () => {
    setFilters({
      ratings: [],
      priceRange: [100, 100000],
      duration: [],
    });
  };
  function getTimeFromMins(mins) {
    var h = (mins / 60) | 0,
      m = mins % 60 | 0;
    var durationformat = h + "hrs " + m + "mins";
    return durationformat;
  }
  const BindPageData = (searchQuery) => {
    setPageLoading(true);
    GetProducts(searchQuery);
  };
  const GetProduct = (e, productQuery) => {
    e.preventDefault();
    navigate(
      "/sightseeing/product/" +
        productQuery.productId +
        "/" +
        params.destinationCode +
        "/" +
        params.destination +
        "/" +
        params.adults +
        "/" +
        params.kids +
        "/" +
        params.travelDate,
      { state: { searchQuery, productQuery } }
    );
  };
  const GetProducts = async (searchQuery) => {
    const result = await apiService.post(
      config.SIGHTSEEINGPRODUCTS,
      searchQuery
    );
    if (result.succeeded) {
      setActivities(result.data.sightSeeingProductResponses);
    }
    setPageLoading(false);
  };
  useEffect(() => {
    setSearchQuery(state.searchQuery);
    BindPageData(state.searchQuery);
  }, []);
  if (loading) return <p>Loading...</p>;
  if (!user) {
    navigate("/");
  }
  return (
    <div id="layout-wrapper">
      <Header />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="card pt-0">
              <div className="p-2">
                <SightSeeingTabs pageName="SEARCH" />
              </div>
              <div className="card-body">
                <div className="row">
                  <aside className="col-lg-3">
                    <div className="w-72 p-4 bg-gray-100 border-r">
                      <h3 className="text-lg font-bold mb-4">Filters</h3>
                      {/* Rating Filter */}
                      <div style={{ marginTop: "10px" }}>
                        <p className="text-muted text-uppercase fs-12 fw-medium mb-2">
                          Ratings
                        </p>
                        {[5, 4, 3, 2, 1].map((rating) => (
                          <div key={rating}>
                            <label
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                              }}
                            >
                              <input
                                type="checkbox"
                                checked={filters.ratings.includes(rating)}
                                onChange={() =>
                                  handleFilterChange("ratings", rating)
                                }
                              />
                              {"★".repeat(rating)}
                            </label>
                          </div>
                        ))}
                      </div>
                      <div style={{ marginTop: "10px" }}>
                        <p className="text-muted text-uppercase fs-12 fw-medium mb-2">
                          Price Range
                        </p>
                        <input
                          type="range"
                          min={200}
                          max={100000}
                          value={filters.priceRange[1]}
                          onChange={(e) =>
                            handleFilterChange("priceRange", [
                              200,
                              parseInt(e.target.value),
                            ])
                          }
                        />
                        <div>Up to INR {filters.priceRange[1]}</div>
                      </div>
                      <div style={{ marginTop: "10px" }}>
                        <p className="text-muted text-uppercase fs-12 fw-medium mb-2">
                          Duration Range
                        </p>
                        <input
                          type="range"
                          min={0}
                          max={7200}
                          value={filters.durationRange[1]}
                          onChange={(e) =>
                            handleFilterChange("duration", [
                              0,
                              parseInt(e.target.value),
                            ])
                          }
                        />
                        <div>Up to 24Hrs</div>
                      </div>
                    </div>
                  </aside>
                  <div className="col-lg-9 mt-4 mt-lg-0">
                    {pageLoading ? (
                      // Use our new centering wrapper
                      <div className="branded-loader-wrapper">
                        <BrandedLoader />
                      </div>
                    ) : (
                      // When not loading, show the results
                      <div>
                    <div className="border-bottom mb-3 pb-3">
                      <div className="row align-items-center">
                        <div className="col-6 col-md-8">
                          {" "}
                          <span className="me-3">
                            <span className="text-4">
                              {params.destination}:
                            </span>{" "}
                            <span className="fw-600">
                              {activities.length} tourist places
                            </span>{" "}
                            found
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="hotels-list">
                     
                        
                        {applyFilters(activities).map((a) => (
                          <div className="hotels-item bg-white shadow-md rounded p-3">
                            <div className="row">
                              <div className="col-md-4">
                                <Link to={a.imageURL} target="_blank">
                                  <img
                                    className="img-fluid rounded align-top"
                                    src={a.imageURL}
                                    alt={a.productName}
                                  />
                                </Link>{" "}
                              </div>
                              <div className="col-md-8 ps-3 ps-md-0 mt-3 mt-md-0">
                                <div className="row g-0">
                                  <div className="col-sm-9">
                                    <h4 className="text-dark text-5">
                                      {a.productName}
                                    </h4>
                                    <p>
                                      {Array.from({ length: 5 }, (_, i) => (
                                        <span
                                          className="text-warning fs-5"
                                          key={i}
                                        >
                                          {i < a.rating ? "★" : "☆"}
                                        </span>
                                      ))}
                                    </p>
                                    {a.duration !== 0 ? (
                                      <p className="mb-1">
                                        Duration : {getTimeFromMins(a.duration)}
                                      </p>
                                    ) : (
                                      ""
                                    )}
                                    <p className="mb-1">{a.destinationName}</p>
                                    <p className="mb-1">
                                      {a.description.length > 100
                                        ? `${a.description.substring(
                                            0,
                                            100
                                          )}...`
                                        : a.description}
                                    </p>
                                  </div>
                                  <div className="col-sm-3 text-end d-flex d-sm-block align-items-center">
                                    <div className="text-dark fs-5 fw-500 mb-0 mb-sm-2 me-2 me-sm-0 order-0">
                                      <b>
                                        {a.currencyCode}{" "}
                                        {Math.round(a.salePrice)}
                                      </b>
                                    </div>
                                    <button
                                      onClick={(e) => GetProduct(e, a)}
                                      className="btn btn-md btn-primary full-width fw-medium px-lg-4"
                                    >
                                      View Details
                                      <i className="fa-solid fa-arrow-trend-up ms-2" />
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        
                       ))}
                       </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SightSeeingProducts;